(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './quotes'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./quotes'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.quotes);
    global.index = mod.exports;
  }
})(this, function (exports, _quotes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.quotes = undefined;

  var quotes = _interopRequireWildcard(_quotes);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  exports.quotes = quotes;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/copy/index.js
// module id = 2280
// module chunks = 1